import React from 'react'

import Icon from '../../components/common/icon/Icon'

import GaugeChart from '../../components/common/gaugeChart/GaugeChart'

import './AggregateReportBox.scss'

const AggregateReportBox = ({ drawEmpty, drawEmptyHeight, title, subtitle, showGauge, gaugeValue, gaugeColor, items }) => {
  function renderItem (item, index) {
    const isLoading = (typeof item.value === 'undefined')

    return (
      <div className='aggregate_report_box-lvitem' key={index}>
        <div className='aggregate_report_box-lvitem__label'>{item.label}
          {item.tooltip && <Icon className='frontend-p-left-xs-thin' tooltipText={item.tooltip} family='sli' icon='question' />}
        </div>
        <div className='aggregate_report_box-lvitem__bumper' />
        <div className='aggregate_report_box-lvitem__value'>
          {isLoading && <span className='is-loading' />}
          {!isLoading && <span>{item.value}</span>}
        </div>
      </div>
    )
  }

  const gaugeProps = {
    minimum: 0,
    maximum: 100,
    data: gaugeValue,
    color: gaugeColor
  }

  const emptyHeightStyle = {
    minHeight: drawEmptyHeight
  }

  return (
    <div className='aggregate_report_box'>
      {drawEmpty && <div style={emptyHeightStyle} />}
      {!drawEmpty &&
        <div>
          <div className='aggregate_report_box__header'>
            <div className='aggregate_report_box__title'>
              <h2>{title}</h2>
              {subtitle &&
                <p className='aggregate_report_box__subtitle'>{subtitle}</p>}
            </div>
            {showGauge &&
              <div className='aggregate_report_box__gauge'><GaugeChart {...gaugeProps} /></div>}

          </div>

          {items.map((o, index) => renderItem(o, index))}
        </div>}
    </div>
  )
}

export default AggregateReportBox
